import { render, staticRenderFns } from "./tpeEdit.vue?vue&type=template&id=18983ce0&scoped=true&"
import script from "./tpeEdit.vue?vue&type=script&lang=js&"
export * from "./tpeEdit.vue?vue&type=script&lang=js&"
import style0 from "./tpeEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tpeEdit.vue?vue&type=style&index=1&id=18983ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18983ce0",
  null
  
)

export default component.exports